var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { get } from 'lodash-es';
import { view as bbqView } from '@bilibili-bbq/razor';
import { formatShare, protocolReg } from './common/utils';
import databus from './common/databus';
import templateContent from './base/template';
import clientContent from './base/client';
import appContent from './base/app';
var _a = databus.browser, isBiliApp = _a.isBiliApp, isBbqApp = _a.isBbqApp, isIos = _a.isIos, hasMangaMallSdk = _a.hasMangaMallSdk, biliMangaMallSdkVersion = _a.biliMangaMallSdkVersion;
var biliShare = (function () {
    function showWindow(config) {
        var formattedConfig = formatShare(config);
        if (formattedConfig.change_share) {
            appContent(formattedConfig, 'set');
            clientContent(formattedConfig);
        }
        if (isBiliApp || (hasMangaMallSdk && biliMangaMallSdkVersion >= 300)) {
            appContent(formattedConfig, 'show');
            return;
        }
        if (isBbqApp) {
            bbqView.callShare({
                title: formattedConfig.title,
                content: formattedConfig.desc,
                pic: formattedConfig.pics,
                url: formattedConfig.link
            });
            return;
        }
        templateContent(formattedConfig);
    }
    function setContent(config) {
        var formattedConfig = formatShare(config);
        appContent(formattedConfig, 'set');
        clientContent(formattedConfig);
    }
    function formatImageShareConfig(imageShareConfig) {
        var title = imageShareConfig.title, desc = imageShareConfig.desc, link = imageShareConfig.link, pics = imageShareConfig.pics, edit_content = imageShareConfig.edit_content, shareChannelQueue = imageShareConfig.shareChannelQueue, pictureList = imageShareConfig.pictureList, share_id = imageShareConfig.share_id, share_origin = imageShareConfig.share_origin, sid = imageShareConfig.sid, oid = imageShareConfig.oid;
        var text = desc;
        var url = link;
        var imgSrc = get(imageShareConfig, 'pictureList.0.img_src', '');
        var imageUrl = protocolReg(imgSrc || pics);
        var customMpcData = {
            share_id: share_id,
            share_origin: share_origin,
            sid: sid,
            oid: oid,
            shareChannelQueue: shareChannelQueue,
            dynamic: {
                title: title,
                content_id: 1,
                content_type: isIos ? 2048 : 12,
                cover_url: imageUrl,
                description: edit_content,
                author_id: 123,
                author_name: '',
                images: ['', '', ''],
                images_online: JSON.stringify({
                    pictureList: pictureList,
                }),
                publish: true,
                edit_content: edit_content,
                repost_code: 123,
                sketch: {
                    title: title,
                    desc_text: text,
                    biz_type: 3,
                    cover_url: imageUrl,
                    target_url: url
                }
            },
            default: {
                type: 'image',
                title: title,
                text: text,
                url: url,
                imageUrl: imageUrl,
            }
        };
        var _customParams = imageShareConfig.customMpcData || {};
        Object.keys(_customParams).forEach(function (key) {
            customMpcData[key] = _customParams[key];
        });
        var shareConfig = __assign(__assign({}, imageShareConfig), { customMpcData: customMpcData });
        return shareConfig;
    }
    function showWindowTypeImage(imageShareConfig) {
        showWindow(formatImageShareConfig(imageShareConfig));
    }
    function setContentTypeImage(imageShareConfig) {
        setContent(formatImageShareConfig(imageShareConfig));
    }
    return {
        showWindow: showWindow,
        setContent: setContent,
        showWindowTypeImage: showWindowTypeImage,
        setContentTypeImage: setContentTypeImage,
    };
})();
export default biliShare;
